export const SizeCompare_DE = [
  ['Grösse des Gletschers im Vergleich'],
  ['Schweiz', '41’285 km²'],
  ['Thwaites-Gletscher', '192’000 km²'],
  [<>Gross&shy;britannien</>, '243’610 km²'],
]

export const SizeCompare_FR = [
  ['FR_Grösse des Gletschers im Vergleich'],
  ['FR_Schweiz', '41’285 km²'],
  ['FR_Thwaites-Gletscher', '192’000 km²'],
  [<>FR_Gross&shy;britannien</>, '243’610 km²'],
]
